import { render, staticRenderFns } from "./external_content.vue.js?vue&type=template&id=a3889202&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./external_content.vue?vue&type=template&id=a3889202&vue3"
import script from "./external_content.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./external_content.vue?vue&type=script&lang=js&vue3"
export * from "./external_content.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./external_content.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports